<template>
  <div class="MainBlock">
    <h1 class="mainText">Welcome to my task manager!</h1>
    <router-link to="/tasks">
      <button class="mainBtn">
        View tasks
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "MainPage",
}
</script>

<style>
.MainBlock {
  margin: 40% auto;
  display: flex;
  flex-direction: column;
  align-items: center;

}

.mainText {
  font-size: 1.8em;
  margin: 0.25em 0 0.5em;
}

.mainBtn {
  width: 220px;
  height: 50px;
  border: none;
  outline: none;
  color: #fff;
  background: #111;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
}

.mainBtn:before {
  content: '';
  background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity .3s ease-in-out;
  border-radius: 10px;
}

.mainBtn:active {
  color: #000
}

.mainBtn:active:after {
  background: transparent;
}

.mainBtn:hover:before {
  opacity: 1;
}

.mainBtn:after {
  z-index: -1;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: #111;
  left: 0;
  top: 0;
  border-radius: 10px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}


</style>